import type { App } from 'vue'
import { createPinia } from 'pinia'

const pinia = createPinia()

export function setupStore(app: App) {
  app.use(pinia)
}

export { pinia }

/* 统一导出各 store，页面直接 `import { useUserStore } from '@/store'` */
export { useUserStore } from './user'
export { usePermissionStore } from './permission'
export { useTabsStore } from './tabs'
export { useAppStore } from './app'
